<template>
  <div class="modal-parent">
    <Loading v-if="loading" />
    <div class="modal">
      <!-- Header -->
      <a href="#" class="close" @click.prevent="$emit('close')">Close</a>
      <h2 v-if="!element_id">Add a new Rep.</h2>
      <h2 v-if="element_id">Edit this Rep.</h2>
      <!-- Form -->
      <FormulateForm @submit="addEditContact">
        <FormulateInput
          type="text"
          v-model="first_name"
          label="First name"
          placeholder="e.g. John"
          validation="required"
          error-behavior="submit"
        />
        <FormulateInput
          type="text"
          v-model="last_name"
          label="Last name"
          placeholder="e.g. Smith"
          validation="required"
          error-behavior="submit"
        />
        <FormulateInput
          type="email"
          v-model="email"
          label="Email"
          placeholder="e.g. example@gmail.com"
          validation="required"
          error-behavior="submit"
        />
        <FormulateInput
          type="select"
          :options="timezones"
          v-model="tac_timezone"
          label="Timezone"
          validation="required"
          error-behavior="submit"
        />
        <FormulateInput
          type="text"
          v-model="tac_zoom_link"
          label="Zoom link"
          validation="required"
          error-behavior="submit"
        />
        <FormulateInput type="submit" name="Submit" />
      </FormulateForm>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: null,
      timezones: [
        {
          label: "Pacific Time",
          value: "America/Los_Angeles",
        },
        {
          label: "Mountain Time",
          value: "America/Denver",
        },
        {
          label: "Central Time",
          value: "America/Chicago",
        },
        {
          label: "Eastern Time",
          value: "America/New_York",
        },
      ],
      first_name: null,
      last_name: null,
      email: null,
      tac_timezone: null,
      tac_zoom_link: null,
      tac_organisation: null,
    };
  },

  methods: {
    getContact: async function () {
      try {
        this.loading = true;
        const response = await this.$axios({
          method: "get",
          url: "https://enfhx8chnmicroq.m.pipedream.net",
          params: {
            contact_id: this.element_id,
          },
        });

        const contact = response.data.contact.properties

        this.first_name = contact.firstname;
        this.last_name = contact.lastname;
        this.email = contact.email;
        this.tac_timezone = contact.tac_timezone;
        if (!this.timezones.find(element => element.value === this.tac_timezone)) {
          this.timezones.push({
            label: this.tac_timezone,
            value: this.tac_timezone,
          })
        }
        this.tac_zoom_link = contact.tac_zoom_link;
        this.tac_organisation = contact.tac_organisation;
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    addEditContact: async function () {
      try {
        this.loading = true;

        let tac_organisation;
        if (this.tac_organisation) {
          tac_organisation = this.tac_organisation;
        } else {
          if (this.is_admin_rep) {
            tac_organisation = "superior_press";
          } else {
            tac_organisation = this.apidata.system.organisation_id;
          }
        }

        const response = await this.$axios({
          method: "post",
          url: "https://enkuzvv6jj55m5k.m.pipedream.net",
          data: {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            tac_timezone: this.tac_timezone,
            tac_zoom_link: this.tac_zoom_link,
            contact_id: this.element_id,
            tac_organisation,
            tac_system: this.apidata.system.system_id,
          },
        });

        const action = response.data;
        this.$toast.success(action);
        if (action === "Created") {
          this.$emit("created");
        }
        this.$emit("close");
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  created: function () {
    if (this.element_id) this.getContact();
  },

  props: ["element_id", "is_admin_rep"],
};
</script>

<style scoped>
</style>